import { type FC, type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import PasswordInput from '@/components/ui/PasswordInput';

export const RegisterForm: FC = () => {
  const { register, isLoading, error, clearError } = useAuth();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();
    setValidationError(null);

    if (password.length < 8) {
      setValidationError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    try {
      await register({ email, password, firstName, lastName });
    } catch {
      // Error is handled by the store
    }
  };

  const displayError = validationError || error;

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-md)',
        width: '100%',
        maxWidth: '400px',
      }}
    >
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, textAlign: 'center' }}>
        Create your account
      </h1>

      {displayError && (
        <div
          role="alert"
          style={{
            padding: 'var(--spacing-sm) var(--spacing-md)',
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid var(--color-danger)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--color-danger)',
            fontSize: 'var(--font-size-sm)',
          }}
        >
          {displayError}
        </div>
      )}

      <Input
        label="Prénom"
        type="text"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="Votre prénom"
        required
        autoComplete="given-name"
      />

      <Input
        label="Nom"
        type="text"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        placeholder="Votre nom"
        required
        autoComplete="family-name"
      />

      <Input
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="vous@exemple.com"
        required
        autoComplete="email"
      />

      <PasswordInput
        label="Mot de passe"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Au moins 8 caractères"
        required
        minLength={8}
        autoComplete="new-password"
        helperText="Un seul champ — clique sur 👁 pour vérifier ce que tu tapes."
      />

      <Button type="submit" isLoading={isLoading} style={{ width: '100%' }}>
        Créer un compte
      </Button>

      <p
        style={{
          textAlign: 'center',
          fontSize: 'var(--font-size-sm)',
          color: 'var(--color-text-muted)',
        }}
      >
        Déjà un compte ? <Link to="/login">Se connecter</Link>
      </p>
    </form>
  );
};

export default RegisterForm;
